/**
 * 商品
 */
import axios from 'axios';
import * as yup from 'yup';
import { apiProxy } from '../util-lib/http';
import { ensureParams } from '../util-lib/api-proxy';
import * as utilObject from '../util-lib/object';

const { document, location } = window;
const REFERRER = document.referrer || location.href;

/**
 * 商品列表/搜索
 * @param {object} params 搜索参数
 */
export async function search(params = search._definedParams) {
  params = ensureParams(params, search._definedParams);

  const api = 'api/v1.15/Poi/Mobile/GoodsListSearch';
  const data = await apiProxy.post(api, params, {
    cancelToken: new axios.CancelToken((cancel) => {
      search.cancel = cancel;
    })
  });

  return utilObject.get(data, 'poiGoodListSearch.data', []);
}
search._definedParams = {
  regionId: 0,
  cityId: 0,
  catId: 0,
  tagId: 0,
  ticketingTime: 0,
  orderBy: '',
  ndbf: 0,
  keyword: '',
  nextPage: '',
  ignoreAggs: 0,
  userId: 0,
  onePage: 15,
  poiSource: 0,
  flashSaleHash: '',
  couponStatus: 0,
  topSale: 0,
  referer: REFERRER,
  orderCityId: '',
  sortCityId: ''
};

/**
 * 商品列表/搜索 3.0 版本
 * @param {object} params 搜索参数
 */
export async function searchV30(params = search._definedParams) {
  params = ensureParams(params, searchV30._definedParams);

  const api = 'api/v1.0/Poi/Goods/GoodsListSearch';
  const data = await apiProxy.get(api, {
    params,
    cancelToken: new axios.CancelToken((cancel) => {
      searchV30.cancel = cancel;
    })
  });

  return utilObject.get(data, 'goodsListSearch.data', []);
}

searchV30._definedParams = {
  regionIds: '',
  cityIds: '',
  categoryIds: '',
  tagIds: '',
  ticketingTimes: '',
  sortBy: '',
  ndbfs: '0',
  keyword: '',
  queryHash: '',
  page: 1,
  poiSource: '',
  referer: REFERRER,
  outDestinationFrom: '0',
  outDestinationId: '',
  outDestinationType: ''
};

// // 根据目的地 搜索关键字 筛选出 关键字在该目的地的列表 还有其余区域的列表
// sortSearch._definedParams = {
//   regionId: 0,
//   cityId: 0,
//   catId: 0,
//   tagId: 0,
//   ticketingTime: 0,
//   orderBy: '',
//   ndbf: 0,
//   keyword: '',
//   nextPage: '',
//   ignoreAggs: 0,
//   userId: 0,
//   onePage: 15,
//   poiSource: 0,
//   flashSaleHash: '',
//   couponStatus: 0,
//   topSale: 0,
//   referer: REFERRER,
//   orderCityId: ''
// };
// export async function sortSearch(params = sortSearch._definedParams) {
//   params = ensureParams(params, sortSearch._definedParams);

//   const api = 'api/v1.14/Poi/Mobile/GoodsListsortSearch';
//   const data = await apiProxy.post(api, params, {
//     cancelToken: new axios.CancelToken((cancel) => {
//       search.cancel = cancel;
//     })
//   });

//   return utilObject.get(data, 'poiGoodListSearch.data', []);
// }

/**
 * 推荐用户商品
 */
export async function getRecommendList() {
  const api = 'api/v1.0/Poi/Mobile/GoodsListRecommend';
  const data = await apiProxy.get(api);

  return utilObject.get(data, 'poiGoodsListRecommend.data', []);
}

orderRebateGoodsList._definedParams = {
  orderPaySn: '',
  page: 1
};

/**
 * 搜索 3.0 的推荐商品接口（商品字段有调整）
 * @returns {Promise<*>}
 */
export async function getRecommendList30() {
  const api = 'api/v1.0/Poi/Goods/GoodsListRecommend';
  const data = await apiProxy.get(api);

  return utilObject.get(data, 'goodsListRecommend.data', []);
}

/**
 * 专属优惠页面的商品列表
 */
export async function orderRebateGoodsList(params = orderRebateGoodsList._definedParams) {
  const api = 'api/v1.0/Poi/Mobile/OrderRebate/GoodsList';
  const data = await apiProxy.get(api, { params });

  return data.poiOrderRebateGoodsList.data;
}

getGoodsDetail._definedParams = {
  goodsId: ''
};

/**
 * 获取商品详情页基础信息
 */
export async function getGoodsDetail(params = getGoodsDetail._definedParams) {
  const api = 'api/v1.0/Poi/Goods/GoodsDetail';
  params = ensureParams(params, getGoodsDetail._definedParams);
  const dataSchema = yup.object().shape({
    getGoodsDetail: yup.object().shape({
      data: yup.object().shape({
        ageAttentions: yup.string(),
        bookAttentions: yup.string(),
        canAddCart: yup.bool(),
        canSell: yup.bool(),
        cancellation: yup.string(),
        cityId: yup.number(),
        regionId: yup.number(),
        clauseAttentions: yup.array(),
        commonQuestion: yup.array(),
        coverImage: yup.string(),
        descriptionWap: yup.string(),
        finalPrice: yup.number().required(),
        id: yup.number().required(),
        isFavorite: yup.bool(),
        isSimplePattern: yup.bool(),
        keyPoints: yup.array(),
        lightspot: yup.string(),
        name: yup.string().required(),
        orderRemind: yup.string(),
        salesVolume: yup.number(),
        simpleDescription: yup.string(),
        trafficReminder: yup.string(),
        usageMethod: yup.string()
      })
    })
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getGoodsDetail.data;
}


getGoodsPkgList._definedParams = {
  goodsId: ''
};

/**
 * 获取商品详情页套餐列表
 */
export async function getGoodsPkgList(params = getGoodsPkgList._definedParams) {
  const api = 'api/v1.0/Poi/Goods/Packages';
  params = ensureParams(params, getGoodsPkgList._definedParams);
  const dataSchema = yup.object().shape({
    getGoodsPackages: yup.object().shape({
      data: yup.array()
    })
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getGoodsPackages.data;
}

getGoodsSalesComboList._definedParams = {
  goodsId: ''
};

/**
 * 获取商品详情页组合优惠列表
 */
export async function getGoodsSalesComboList(params = getGoodsSalesComboList._definedParams) {
  const api = 'api/v1.0/Poi/Goods/SaleCombinatoryList';
  params = ensureParams(params, getGoodsSalesComboList._definedParams);
  const dataSchema = yup.object().shape({
    getSaleCombinatoryList: yup.object().shape({
      data: yup.array()
    })
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getSaleCombinatoryList.data;
}

getGoodsRecommends._definedParams = {
  goodsId: ''
};

/**
 * 获取商品详情页商品推荐列表
 */
export async function getGoodsRecommends(params = getGoodsRecommends._definedParams) {
  const api = 'api/v1.0/Poi/Goods/RecommendsWap';
  params = ensureParams(params, getGoodsRecommends._definedParams);
  const dataSchema = yup.object().shape({
    getRecommendsWap: yup.object().shape({
      data: yup.array()
    })
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getRecommendsWap.data;
}

getGoodsReview._definedParams = {
  goodsId: ''
};

/**
 * 获取商品详情页商品评论
 */
export async function getGoodsReview(params = getGoodsReview._definedParams) {
  const api = 'api/v1.0/Poi/Goods/GoodsReview';
  params = ensureParams(params, getGoodsReview._definedParams);
  const dataSchema = yup.object().shape({
    getRecommendsWap: yup.object().shape({
      data: yup.object().shape({
        averageScore: yup.string(),
        averageScoreTitle: yup.string(),
        goodsId: yup.number(),
        review: yup.object()
      }).nullable()
    })
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getGoodsReview.data;
}


setGoodsFavorite._definedParams = {
  goodsId: ''
};

/**
 * 商品详情页商品收藏
 */
export async function setGoodsFavorite(params = setGoodsFavorite._definedParams) {
  const api = 'api/v1.0/Poi/Goods/GoodsFavorite';
  params = ensureParams(params, setGoodsFavorite._definedParams);
  const data = await apiProxy.post(api, params);
  return data.goodsFavorite.data;
}

cancelGoodsFavorite._definedParams = {
  goodsId: ''
};

/**
 * 取消商品详情页商品收藏
 */
export async function cancelGoodsFavorite(params = cancelGoodsFavorite._definedParams) {
  const api = 'api/v1.0/Poi/Goods/CancelFavorite';
  params = ensureParams(params, cancelGoodsFavorite._definedParams);
  const data = await apiProxy.post(api, params);
  return data.cancelGoodsFavorite.data;
}

getCartNum._definedParams = {
  userid: '',
  session_id: ''
};

/**
 * 获取商品详情页购物车数量
 */
export async function getCartNum(params = getCartNum._definedParams) {
  const api = 'api/v1.8/Poi/Goods/Quantity';
  params = ensureParams(params, getCartNum._definedParams);
  const dataSchema = yup.object().shape({
    'poi_group__Poi.Goods.Quantity_v1_8': yup.object().shape({
      data: yup.object().shape({
        quantity: yup.number()
      })
    })
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data['poi_group__Poi.Goods.Quantity_v1_8'].data;
}
getGoodsPackageList._definedParams = {
  goodsId: 0
};

/**
 * 获取商品的套餐列表
 */
export async function getGoodsPackageList(params = getGoodsPackageList._definedParams) {
  const api = 'api/v1.0/Poi/Goods/Package';
  const data = await apiProxy.get(api, { params });
  return data.getGoodsPackageList.data;
}

/**
 * 获取商品的报价日历
 */
export async function getGoodsPackageCalendar(params) {
  const api = 'api/v1.0/Poi/Goods/PackageCalendar';

  const packageSchema = yup.object().shape({
    id: yup.number().required(),
    name: yup.string(),
    needTravelDate: yup.number(),
    minNum: yup.number(),
    minAddOptionNum: yup.number(),
    needBookBefore: yup.number(),
    needConfirm: yup.number(),
    bookBeforeTips: yup.string(),
    soldOut: yup.bool(),
    startTime: yup.number(),
    endTime: yup.number(),
    packageCalendar: yup.object()
  });

  const dataSchema = yup.object().shape({
    getGoodsPackageCalendar: yup.object().shape({
      data: yup.object().shape({
        package: yup.array(packageSchema).required()
      }).required()
    })
  });

  const data = await apiProxy.get(api, { params }, { dataSchema });

  return data.getGoodsPackageCalendar.data;
}

getSkuCalendar._definedParams = {
  skuId: ''
};

// 获取规格的报价日历，优化后的日历接口
export async function getSkuCalendar(params = getSkuCalendar._definedParams) {
  const api = 'api/v1.0/Poi/Goods/SkuCalendar';
  params = ensureParams(params, getSkuCalendar._definedParams);
  const data = await apiProxy.get(api, { params });
  return data.getSkuCalendar.data;
}


/**
 * 获取商品的SKU
 */
export async function getGoodsSku(params) {
  const api = 'api/v1.0/Poi/Goods/Skus';
  // sku属性schema
  const attrSchema = yup.object().shape({
    id: yup.number().required(),
    attrName: yup.string(),
    type: yup.number(),
    value: yup.array(
      yup.object().shape({
        id: yup.number().required(),
        value: yup.string()
      })
    )
  });
  // 可用sku的schema
  const optionSchema = yup.object().shape({
    optionId: yup.number().required(),
    attrValueIds: yup.array(yup.number()),
    canSell: yup.bool()
  });
  // 返回结果的schema
  const dataSchema = yup.object().shape({
    getGoodsSkus: yup.object().shape({
      data: yup.object().shape({
        attrs: yup.array(attrSchema),
        options: yup.array(optionSchema)
      }).required()
    })
  });
  const data = await apiProxy.post(api, params, { dataSchema });
  return data.getGoodsSkus.data;
}

getGoodsOptions._definedParams = {
  optionId: 0,
  travelDate: ''
};

// 通过sku id获取对应的规格和服务
export async function getGoodsOptions(params = getGoodsOptions._definedParams) {
  params = ensureParams(params, getGoodsOptions._definedParams);
  const api = 'api/v1.0/Poi/Goods/RelatedSkusAdditions';
  const data = await apiProxy.post(api, params);
  return data.getRelatedSkusAdditions.data;
}

serviceRecord._definedParams = {
  goodsId: '',
  userId: '',
  serviceCode: ''
};
// 客服系统 统计商品详情页pv/uv
export async function serviceRecord(params = serviceRecord._definedParams) {
  params = ensureParams(params, serviceRecord._definedParams);
  const api = 'api/v1.0/Poi/Goods/StoreBrowsingHistory';
  const data = await apiProxy.post(api, params);
  return data.storeBrowsingHistory.data;
}

rankListContent._definedParams = {
  destinationType: '',
  destinationId: '',
  ruleId: '0',
  preview: '0'
};

// 榜单标签内容
export async function rankListContent(params) {
  params = ensureParams(params, rankListContent._definedParams);
  const api = 'api/v1.0/Poi/Cms/TopBoard/TopBoards';
  const data = await apiProxy.get(api, { params });
  return data.getTopBoards.data;
}

expectedGoodsDetail._definedParams = {
  articleId: 0,
  topBoardId: 0
};

// 无售商品详情
export async function expectedGoodsDetail(params) {
  params = ensureParams(params, expectedGoodsDetail._definedParams);
  const api = 'api/v1.0/Poi/Cms/Article/Detail';
  const data = await apiProxy.post(api, params);
  return data.getCmsArticleDetail.data;
}

expectedGoodsStatus._definedParams = {
  articleId: 0
};

// 无售商品状态
export async function expectedGoodsStatus(params) {
  params = ensureParams(params, expectedGoodsStatus._definedParams);
  const api = 'api/v1.0/Poi/Cms/Article/WantStatus';
  const data = await apiProxy.post(api, params);
  return data.getCmsArticleWantStatus.data;
}

toggleExpectedGoodsStatus._definedParams = {
  articleId: 0,
  isWant: 0
};

// 切换无售商品状态
export async function toggleExpectedGoodsStatus(params) {
  params = ensureParams(params, toggleExpectedGoodsStatus._definedParams);
  const api = 'api/v1.0/Poi/Cms/Article/Want';
  const data = await apiProxy.post(api, params);
  return data.setCmsArticleWant.data;
}

export async function getSearchHotWord(params) {
  params = ensureParams(params, getSearchHotWord.__definedParams);
  const api = 'api/v1.0/Poi/Goods/GoodsListHotWord';
  const data = await apiProxy.post(api, params);
  return data.goodsListHotWord.data;
}

getSearchHotWord.__definedParams = {
  regionId: '0',
  cityId: '0'
};

export async function getTypeAhead(params) {
  params = ensureParams(params, getTypeAhead.__definedParams);
  const api = 'api/v1.0/Poi/Goods/GoodsListAssociate';
  const data = await apiProxy.get(api, {
    params,
    cancelToken: new axios.CancelToken((cancel) => {
      getTypeAhead.cancel = cancel;
    })
  });
  return data.goodsListAssociate.data;
}

getTypeAhead.__definedParams = {
  keyword: '',
  outDestinationFrom: '0',
  outDestinationId: '',
  outDestinationType: ''
};

/**
 * 检查商品购买限制
 */
export async function checkBuyLimit(params) {
  params = ensureParams(params, checkBuyLimit.__definedParams);
  const api = 'api/v1.0/Poi/Goods/CheckBuyLimit';
  const data = await apiProxy.get(api, { params });
  return data.checkBuyLimit.data;
}

checkBuyLimit.__definedParams = {
  goodsId: '',
  activityHash: '',
  awardToken: ''
};
